<template>
  <div class="hero">
    <div class="login-page-hero"></div>
    <div class="image-group">
      <img class="opendock-logo" :src="logo" />
    </div>
    <div class="auth-page-tag">Data migration tool for Opendock</div>
  </div>
</template>

<script lang="ts" setup>
import logo from '@/../public/images/opendock_loadsmart_logo.png';
</script>
